import {AppDialog} from "../component/appDialog";

/**
 * Created by Owner on 2016/10/20.
 */
export class CommonUtil {
    static copyToClipboard(text: string, toastCtrl) {
        let textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.contentEditable = 'true';
        textarea.readOnly = false;
        textarea.style.background = 'transparent';
        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
        document.body.appendChild(textarea);
        textarea.setSelectionRange(0, text.length);
        document.execCommand("copy");
        textarea.select();
        try {
            document.execCommand("copy");  // Security exception may be thrown by some browsers.
        } catch (ex) {
            console.warn("Copy to clipboard failed.", ex);
            return false;
        } finally {
            document.body.removeChild(textarea);
            AppDialog.toast({
                toastCtrl: toastCtrl,
                message: "Copied"
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/util/commonUtil.ts